var MainLayout = import('layouts/Main');
var LoginLayout = import('layouts/Login.vue');
var RecoveryLayout = import('layouts/Recovery.vue');
var routes = [{
  path: '/',
  redirect: '/login'
}, {
  path: '/login',
  components: {
    mainView: function mainView() {
      return LoginLayout;
    }
  }
}, {
  path: '/recovery',
  components: {
    mainView: function mainView() {
      return RecoveryLayout;
    }
  }
}, {
  path: '/schedule',
  components: {
    mainView: function mainView() {
      return MainLayout;
    }
  },
  children: [{
    path: '',
    components: {
      contentView: function contentView() {
        return import('pages/Schedule.vue');
      }
    }
  }],
  meta: {
    showStaticControls: ['DateRange', 'Departments']
  }
}, {
  path: '/timetable',
  components: {
    mainView: function mainView() {
      return MainLayout;
    }
  },
  meta: {
    showStaticControls: ['DateRange', 'Departments'],
    hideDateTo: true
  },
  children: [{
    path: '',
    components: {
      contentView: function contentView() {
        return import('pages/Timetable.vue');
      }
    }
  }]
}, {
  path: '/staff',
  components: {
    mainView: function mainView() {
      return MainLayout;
    }
  },
  children: [{
    path: '',
    components: {
      contentView: function contentView() {
        return import('pages/Staff.vue');
      }
    }
  }],
  meta: {
    showStaticControls: ['DateRange', 'Departments']
  }
}, {
  path: '/forecast',
  components: {
    mainView: function mainView() {
      return MainLayout;
    }
  },
  children: [{
    path: '',
    components: {
      contentView: function contentView() {
        return import('pages/Forecast.vue');
      }
    }
  }],
  meta: {
    showStaticControls: ['DateRange', 'Departments']
  }
}, {
  path: '/exchange',
  components: {
    mainView: function mainView() {
      return MainLayout;
    }
  },
  children: [{
    path: '',
    components: {
      contentView: function contentView() {
        return import('pages/Exchange.vue');
      }
    }
  }],
  meta: {
    showStaticControls: ['DateRange', 'Departments']
  }
}, {
  path: '/reports',
  components: {
    mainView: function mainView() {
      return MainLayout;
    }
  },
  children: [{
    path: '',
    redirect: '/reports/days'
  }, {
    path: 'days',
    components: {
      contentView: function contentView() {
        return import('pages/Reports.vue');
      }
    }
  }, {
    path: 'indicators',
    components: {
      contentView: function contentView() {
        return import('pages/Reports.vue');
      }
    }
  }],
  meta: {
    showStaticControls: ['DateRange', 'Departments']
  }
}, {
  path: '/settings',
  components: {
    mainView: function mainView() {
      return MainLayout;
    }
  },
  children: [{
    path: '',
    redirect: '/settings/departments/' // components: { contentView: () => import('pages/Settings.vue') }

  }, {
    path: 'departments',
    components: {
      contentView: function contentView() {
        return import('pages/Settings/Departments.vue');
      }
    }
  }, {
    path: 'timetable-templates',
    components: {
      contentView: function contentView() {
        return import('pages/Settings/TimetableTemplates.vue');
      }
    }
  },
  /*
  {
    path: 'work-type-names',
    components: { contentView: () => import('pages/Settings/WorkTypeNames.vue') }
  },
  {
    path: 'operation-type-names',
    components: { contentView: () => import('pages/Settings/OperationTypeNames.vue') }
  },
  */
  {
    path: 'operations',
    components: {
      contentView: function contentView() {
        return import('pages/Settings/OperationTypeNames.vue');
      }
    }
  }, {
    path: 'business-drivers',
    components: {
      contentView: function contentView() {
        return import('pages/Settings/OperationTypeNames.vue');
      }
    }
  }, {
    path: 'work-types',
    components: {
      contentView: function contentView() {
        return import('pages/Settings/WorkTypes.vue');
      }
    }
  }, {
    path: 'positions',
    components: {
      contentView: function contentView() {
        return import('pages/Settings/Positions.vue');
      }
    }
  }, {
    path: 'access-groups',
    components: {
      contentView: function contentView() {
        return import('pages/Settings/AccessGroups.vue');
      }
    }
  }, {
    path: 'load-templates',
    components: {
      contentView: function contentView() {
        return import('pages/Settings/LoadTemplates.vue');
      }
    }
  }, {
    path: 'tickpoints',
    components: {
      contentView: function contentView() {
        return import('pages/Settings/Tickpoints.vue');
      }
    }
  }]
}, {
  path: '/notifications',
  component: function component() {
    return MainLayout;
  },
  children: [{
    path: '',
    components: {
      contentView: function contentView() {
        return import('pages/Notifications.vue');
      }
    }
  }]
}]; // Always leave this as last one

/*
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: () => import('pages/Error404.vue')
  })
}
*/

export default routes;